import { useEffect } from "react";
import Header from "components/common/header";

export default function Policy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <section className="flex flex-col gap-12 px-4 py-12 mt-16">
        <h3 className="text-[32px] font-semibold">
          Политика конфиденциальности
        </h3>
        <span>
          <h6 className="text-sm font-bold uppercase">1. Определения</h6>
          <p className="text-sm">
            Интернет проект www.garyshker.com (далее – www.garyshker.com, «мы»)
            серьезно относится к вопросу конфиденциальности информации своих
            клиентов и посетителей сайта www.garyshker.com (далее – «вы»,
            «посетители сайта»). Персонифицированной мы называем информацию,
            содержащую персональные данные (например: ФИО, логин или название
            компании) посетителя сайта, а также информацию о действиях,
            совершаемых вами на сайте URL. (например: заказ посетителя сайта с
            его контактной информацией). Анонимными мы называем данные, которые
            невозможно однозначно идентифицировать с конкретным посетителем
            сайта (например: статистика посещаемости сайта).
          </p>
        </span>
        <span>
          <h6 className="text-sm font-bold uppercase">
            2. Использование информации
          </h6>
          <p className="text-sm">
            Мы используем персонифицированную информацию конкретного посетителя
            сайта исключительно для обеспечения ему качественного оказания услуг
            и их учета. Мы не раскрываем персонифицированных данных одних
            посетителей сайта www.garyshker.com другим посетителям сайта. Мы
            никогда не публикуем персонифицированную информацию в открытом
            доступе и не передаем ее третьим лицам. Исключением являются лишь
            ситуации, когда предоставление такой информации уполномоченным
            государственным органам предписано действующим законодательством
            Республики Казахстан. Мы публикуем и распространяем только отчеты,
            построенные на основании собранных анонимных данных. При этом отчеты
            не содержат информацию, по которой было бы возможным
            идентифицировать персонифицированные данные пользователей услуг. Мы
            также используем анонимные данные для внутреннего анализа, целью
            которого является развитие продуктов и услуг www.garyshker.com
          </p>
        </span>
        <span>
          <h6 className="text-sm font-bold uppercase">3. Ссылки</h6>
          <p className="text-sm">
            Сайт www.garyshker.com может содержать ссылки на другие сайты, не
            имеющие отношения к нашей компании и принадлежащие третьим лицам. Мы
            не несем ответственности за точность, полноту и достоверность
            сведений, размещенных на сайтах третьих лиц, и не берем на себя
            никаких обязательств по сохранению конфиденциальности информации,
            оставленной вами на таких сайтах.
          </p>
        </span>
        <span>
          <h6 className="text-sm font-bold uppercase">
            4. Ограничение ответственности
          </h6>
          <p className="text-sm">
            Мы делаем все возможное для соблюдения настоящей политики
            конфиденциальности, однако, мы не можем гарантировать сохранность
            информации в случае воздействия факторов находящихся вне нашего
            влияния, результатом действия которых станет раскрытие информации.
            Сайт www.garyshker.com и вся размещенная на нем информация
            представлены по принципу "как есть” без каких-либо гарантий. Мы не
            несем ответственности за неблагоприятные последствия, а также за
            любые убытки, причиненные вследствие ограничения доступа к сайту
            www.garyshker.com или вследствие посещения сайта и использования
            размещенной на нем информации.
          </p>
        </span>
        <span>
          <h6 className="text-sm font-bold uppercase">5. Контакты</h6>
          <p className="text-sm">
            По вопросам, касающимся настоящей политики, просьба обращаться по
            адресу info@garyshker.com, Казахстан, Алматы, Проспект Достык, дом
            дом 162, кв/офис корпус 4
          </p>
        </span>
      </section>
    </>
  );
}
